import React, { Component } from "react";

// import { Container } from './styles';

export default class ListStatus extends Component {
  render() {
    return (
      <div className="form-group row">
        <label className="col-sm-3 control-label">Status:</label>
        <div className="col-sm-9">
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text">
                <i className="fa fa-list"></i>
              </label>
            </div>
            <select
              className="custom-select"
              defaultValue={"null"}
              id="inputGroupSelect01"
              value={this.props.status ? this.props.status : 0}
              onChange={this.props.change}
            >
              <option value="null">Escolha o status...</option>
              <option value="Aguardando Análise">Aguardando analise</option>
              <option value="Aguardando Cirurgia">Aguardando Cirurgia</option>
              <option value="Pendências">Pendências</option>
              <option value="Acompanhamento Pós Operatório">
                Acompanhamento Pós Operatório
              </option>
              <option value="Acompanhamento Ambulatorial">
                Acompanhamento Ambulatorial
              </option>
              <option value="Finalizado">Finalizado</option>
            </select>
          </div>
        </div>
      </div>
    );
  }
}
